import { rj } from 'react-rocketjump'
import api from '../api'

export const OrdiniState = rj({
  name: 'Ordini',
  effectCaller: 'configured',
  effect: (t) => (idAzienda) => api.auth(t).get(`/api/order/${idAzienda}/`),
})
